import callApi, { ENDPOINTS } from 'utils/api/callApi'

export interface ITruckNumberSearch {
  id: string
  value: string
}

interface ITruckNumbersSearchList {
  truckNumbers: ITruckNumberSearch[]
}

/**
 * Returns list of Truck Numbers from Carrier
 * @method GET
 * @param carrierId string
 * @returns ITruckNumbersSearchList
 *
 * Used in TruckAutosuggest component
 */
const searchCarrierTruckNumbers = (carrierId: string): Promise<ITruckNumbersSearchList> =>
  callApi({
    endpoint: ENDPOINTS.carriers,
    id: carrierId,
    group: 'truck_numbers',
  })

export default searchCarrierTruckNumbers
